import { useDeleteAlertMutation } from "../../../app/services/alertService";
import { Button } from "../../../components/ui/button"
import { useDialog } from "../../../contexts/dialog-context";
import { handleAsyncToast } from "../../../lib/toastMessageHandler";

type Props = {
    id: number;
    title?:string
}

const DeleteAlerts = ({ id, title }: Props) => {
    const { closeDialog } = useDialog();
    const [deleteAlert] = useDeleteAlertMutation();
    const handelDelete = async () => {
        await handleAsyncToast(
            () => deleteAlert(id).unwrap(),
            {
                loadingMessage: 'Deleting alert...',
                successMessage: 'Alert deleted successfully',
                errorMessage: 'Failed to delete alert. Please try again.'
            }
        )
        closeDialog();
    }
    return (
        <div className="space-y-4">
            <p className="text-gray-600">
                Are you sure you want to delete {title || "this alert"}? This action cannot be undone.
            </p>

            <div className="flex justify-end gap-2">
                <Button
                    variant="outline"
                    onClick={() => closeDialog()}
                >
                    Cancel
                </Button>
                <Button
                    variant="destructive"
                    onClick={handelDelete}
                    className="bg-red-600 hover:bg-red-700"
                >
                    Delete
                </Button>
            </div>
        </div>
    )
}

export default DeleteAlerts